import React from "react";
import { Block, Card } from "framework7-react";
import { getUserAuthData } from "../auth/authHelper";
import MainLayout from "../MainLayout/MainLayout";
import {ProfileCard} from "./ProfileCard/ProfileCard";
import {Withdraw} from "./Withdraw/Withdraw";
import {EarnMoney} from "./EarnMoney/EarnMoney";
import ChartsTest from "./Charts/ChartsTest";
import {ChartBarComponent} from "./Charts/ChartBar";
import {ChartPieComponent} from "./Charts/ChartPieComponent";
import {getStoragedCurrentOperator, getStoragedOperatorInfo,getDefaultAtag, getCurrentAtagLocal} from "../auth/authHelper";

const Dashboard = () => {
    let userData = getUserAuthData();
    let operatorName = getStoragedCurrentOperator();
    let operatorData = getStoragedOperatorInfo();
    const storedAtag = getCurrentAtagLocal();
    const defaultAtag = getDefaultAtag();
    const initialAtag = storedAtag?.length > 0 ? storedAtag : defaultAtag;
    return (
        <MainLayout>
            <Block className='text-align-center' style={{paddingBottom: '30px'}}>
                <ProfileCard data={userData} operatorName={operatorName} operatorData={operatorData} atag={initialAtag} />
                <Card>
                    <div className="grid grid-cols-2 grid-gap">
                        <div><EarnMoney/></div>
                        <div><Withdraw /></div>
                    </div>
                </Card>
                <ChartsTest currency={operatorData?.currency} />
                <ChartBarComponent currency={operatorData?.currency} />
                <ChartPieComponent currency={operatorData?.currency}  />
            </Block>
        </MainLayout>
    );
};

export default Dashboard;
